import { BLACK, PRIMARY_PURPLE } from '../../theme/colorConstants';
import { PRIMARY_FONT } from '../../theme/fontConstants';

const getStyles = ({ theme, sx, disabled, customIconColor, fullWidth }) => {
  const searchBackgroundColor = theme?.searchBox?.bgColor?.lightBkColor;

  // WaeStandardTextField styling
  const waeStandardStyle = {
    width: fullWidth ? '100%' : '300px',
    '& .MuiInputLabel-root': {
      color: BLACK[100],
      fontFamily: PRIMARY_FONT[400],
      marginBottom: '8px',
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: PRIMARY_PURPLE[70],
    },
    '& .MuiInputLabel-root.Mui-error': {
      color: BLACK[100],
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, -9px) scale(0.75)',
    },
    '& .MuiOutlinedInput-root': {
      marginTop: '8px',
    },
  };

  const styleForTextField = { ...waeStandardStyle, ...sx };

  const styleForGrid = {
    backgroundColor: searchBackgroundColor,
  };

  const styleForIcon = {
    color: disabled
      ? theme?.textField?.inputLabel?.iconColor?.disabled
      : customIconColor || theme?.textField?.inputLabel?.iconColor?.enabled,
  };

  const styleForDropDownPaper = {
    padding: theme.spacing(2),
    backgroundColor: searchBackgroundColor,
  };

  return {
    styleForTextField,
    styleForGrid,
    styleForIcon,
    styleForDropDownPaper,
  };
};

export default getStyles;
